"use client";

import { createContext, useContext } from "react";
import type { Config } from "~/i18n/config";

interface LocaleContextValue {
	lang: string;
	domain: Config["domains"][number];
}

export const LocaleContext = createContext<LocaleContextValue | null>(null);

export function useLocale() {
	const ctx = useContext(LocaleContext);

	if (!ctx) {
		throw new Error("LocaleProvider not found");
	}

	return ctx;
}
